module.exports = __webpack_public_path__ + "img/noGlasses.18c6c72e.png";